/* eslint-disable no-else-return */
/* eslint-disable radix */
/* eslint-disable no-underscore-dangle */
import React from 'react';
import moment from 'moment';
import { Formik } from 'formik';
import { useMutation } from '@apollo/client';
import { toast } from 'react-toastify';
import {
  RECORD_ADDED_SUCCESSFULLY,
  RECORD_UPDATED_SUCCESSFULLY,
} from 'components/common/FSBToastify/types';
import { CREATE_COUPON, UPDATE_COUPON } from 'pages/OfferCoupons/CouponGraphQL';
import { ADD_EDIT_CONSTANT } from 'utils/constants';
import {
  convertDateTimeIntoEpochTime,
  couponValidationSchema,
} from 'pages/OfferCoupons/constants';
import ErrorBoundary from 'components/common/ErrorBoundary';
import AddEditOfferCouponForm from './components/AddEditOfferCouponForm';

const AddEditOfferCoupon = ({ drawerToggle, type, currentRow }) => {
  const [updateCoupon] = useMutation(UPDATE_COUPON, {
    onCompleted: () => {
      toast.success(RECORD_UPDATED_SUCCESSFULLY);
      drawerToggle('', ADD_EDIT_CONSTANT.ADD);
    },
    onError: ({ graphQLErrors }) => {
      graphQLErrors.forEach(({ message }) => {
        toast.error(message);
        drawerToggle('', ADD_EDIT_CONSTANT.ADD);
      });
    },
  });

  const [createCoupon] = useMutation(CREATE_COUPON, {
    onCompleted: () => {
      toast.success(RECORD_ADDED_SUCCESSFULLY);
      drawerToggle('', ADD_EDIT_CONSTANT.ADD);
    },
    onError: ({ graphQLErrors }) => {
      graphQLErrors.forEach(({ message }) => {
        toast.error(message);
        drawerToggle('', ADD_EDIT_CONSTANT.ADD);
      });
    },
  });

  const compareDateTime = (fromDate, expiryDate) => {
    const fromDateObj = new Date(fromDate);
    const expiryDateObj = new Date(expiryDate);

    if (fromDateObj < expiryDateObj) {
      return -1; // fromDate is earlier than expiryDate
    } else if (fromDateObj > expiryDateObj) {
      return 1; // fromDate is later than expiryDate
    } else {
      return 0; // fromDate is equal to expiryDate
    }
  };
  const handleSubmit = async (values) => {
    if (compareDateTime(values?.fromDate, values?.expiryDate) === 1) {
      return toast.error(
        'Valid till date and time should be less than Valid from date and time',
      );
    }
    const format = 'DD/MM/YYYY';
    const date1 = moment(values?.fromDate).format(format);
    const date2 = moment(new Date()).format(format);
    try {
      if (type === ADD_EDIT_CONSTANT.EDIT) {
        await updateCoupon({
          variables: {
            couponInput: {
              createdByUserId: values.createdByUserId,
              fromDate: convertDateTimeIntoEpochTime(values?.fromDate),
              expiryDate: convertDateTimeIntoEpochTime(values?.expiryDate),
              // fromDate: Date.parse(values?.fromDate),
              // expiryDate: Date.parse(values?.expiryDate),
              id: parseInt(values?.id),
              code: values.code.toUpperCase(),
              status: values.status,
              discountValue: values.discountValue,
              discountType: values.discountType?.id,
              usageLimit: values.usageLimit,
              currency: values.currency?.id,
            },
          },
        });
      } else {
        await createCoupon({
          variables: {
            couponInput: {
              ...values,
              code: values.code.toUpperCase(),
              discountType: values.discountType?.id,
              currency: values.currency?.id,
              status: date1 === date2 ? 'ACTIVE' : 'PLANNED',
              fromDate: convertDateTimeIntoEpochTime(values?.fromDate),
              expiryDate: convertDateTimeIntoEpochTime(values?.expiryDate),
            },
          },
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div>
      <ErrorBoundary>
        <Formik
          enableReinitialize
          validationSchema={couponValidationSchema}
          initialValues={
            type === ADD_EDIT_CONSTANT.EDIT
              ? {
                  ...currentRow,
                  discountType: {
                    id: currentRow?.discountType,
                    label: currentRow?.discountType,
                  },
                  currency: {
                    id: currentRow?.currency?.id === '101' ? 101 : 233,
                    label: currentRow?.currency?.id === '101' ? 'INR' : 'USD',
                  },
                  fromDate: currentRow?.fromDate,
                  expiryDate: currentRow?.expiryDate,
                }
              : {
                  code: '',
                  expiryDate: moment()
                    .add(1, 'days')
                    .format('MM/DD/YYYY h:mm A'),
                  // expiryDate: moment().format('MM/DD/YYYY h:mm A'),
                  fromDate: moment().format('MM/DD/YYYY h:mm A'),
                  discountType: {
                    id: 'PERCENTAGE',
                    label: 'PERCENTAGE',
                  },
                  currency: {
                    id: 101,
                    label: 'INR',
                  },
                  discountValue: '',
                  usageLimit: '',
                  // status: '',
                }
          }
          onSubmit={handleSubmit}
          children={(props) => {
            return (
              <AddEditOfferCouponForm
                {...props}
                drawerToggle={drawerToggle}
                type={type}
              />
            );
          }}
        />
      </ErrorBoundary>
    </div>
  );
};

export default AddEditOfferCoupon;
